import AccountTreeIcon from "@mui/icons-material/AccountTree";
import CalculateIcon from "@mui/icons-material/Calculate";
import ChatIcon from "@mui/icons-material/Chat";
import InsertChartIcon from "@mui/icons-material/InsertChart";
import PublicIcon from "@mui/icons-material/Public";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import SavingsIcon from "@mui/icons-material/Savings";
import React from "react";
import {AIUseIcon} from "../assets/AIUseIcon";

export const getIcon = (type: string):React.ReactNode => {
    switch (type) {
    case "Opinion": return <ChatIcon htmlColor={"#FFFFFF"}/>;
    case "Economic": return <SavingsIcon htmlColor={"#FFFFFF"}/>;
    case "Geopolitical": return <PublicIcon htmlColor={"#FFFFFF"}/>;
    case "Indirect": return <AccountTreeIcon htmlColor={"#FFFFFF"}/>;
    case "Mathematical": return <CalculateIcon htmlColor={"#FFFFFF"}/>;
    case "Financial Statement Analysis": return <InsertChartIcon htmlColor={"#FFFFFF"}/>;
    case "Financial Analysis": return <InsertChartIcon htmlColor={"#FFFFFF"}/>;
    case "Related Assets Analysis": return <QueryStatsIcon htmlColor={"#FFFFFF"}/>;
    default: return <AIUseIcon color={"#FFFFFF"}/>;
    }
};
